import React, { FunctionComponent, PropsWithChildren, useState } from 'react';

import AlertContext from './AlertContext';
import { AlertEnumType } from '../types/enums/AlertEnumType';
import { AlertType } from '../types';

const AlertProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [alerts, setAlerts] = useState<AlertType[]>([]);

  const createAlert = (message: string, type: AlertEnumType) => {
    setTimeout(() => {
      setAlerts([{ message, type }]);
    }, 10);
  };

  const createAlerts = (messages: string[], type: AlertEnumType) => {
    setTimeout(() => {
      setAlerts(
        messages.map((message) => {
          return { message, type };
        }),
      );
    }, 10);
  };

  const clearAlerts = () => {
    setAlerts([]);
  };

  const removeAlert = (alert: AlertType) => {
    const isEqual = require('react-fast-compare');
    setAlerts(alerts.filter((a) => !isEqual(a, alert)));
  };

  const value = {
    alerts,
    clearAlerts,
    createAlert,
    createAlerts,
    removeAlert,
  };

  return <AlertContext.Provider value={value}>{children}</AlertContext.Provider>;
};

export default AlertProvider;
